import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { CUIStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import { APP_NAME, buildLink, DOMAIN_NAME } from 'connect-dot-com-ui-components/utils/urls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import CUIRouterLink from 'connect-dot-com-ui-components/Components/CUIRouterLink/CUIRouterLink';
import { useLocation } from 'react-router-dom';

const HomepageHeaderNav = () => {
  const {
    trackInteraction
  } = useContext(TrackerContext);

  function trackHeaderClick(linkName) {
    trackInteraction('header nav click', {
      value: linkName
    });
  }

  const location = useLocation();
  return /*#__PURE__*/_jsxs(CUIStack, {
    as: "nav",
    role: "navigation",
    align: "center",
    direction: "row",
    spacing: 4,
    px: 4,
    style: {
      fontWeight: 500
    },
    children: [/*#__PURE__*/_jsx(CUIRouterLink, {
      color: location.pathname === '/' ? 'CARNABY.regular' : undefined,
      variant: "homepage",
      "data-test-id": "nav-home-link",
      to: '/',
      onClick: () => trackHeaderClick('home'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connect.marketingSite.header.nav.home"
      })
    }), /*#__PURE__*/_jsx(CUILink, {
      color: location.pathname === 'members' ? 'CARNABY.regular' : undefined,
      "data-test-id": "nav-members-link",
      variant: "homepage",
      href: buildLink('', {
        domainOverride: DOMAIN_NAME.HUBSPOT,
        hubspotAppOverride: APP_NAME.AUTHED,
        forceNotLocal: true
      }),
      onClick: () => trackHeaderClick('members'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connect.marketingSite.header.nav.members"
      })
    })]
  });
};

export default HomepageHeaderNav;